<div class="container min-vh-100 d-flex justify-content-center align-items-center">
  <form class="text-center" style="min-width: 500px" [formGroup]="loginform" (ngSubmit)="submitAdminLogin()">
    <div class="text-center">
      <h3>{{ apptitle }}</h3>
      <img
        src="../assets/app_icon_modified.png"
        class="mx-auto d-block rounded"
        alt="UPG logo"
        width="100"
        height="100" />
    </div>
    <p></p>

    <div class="input-group mb-3">
      <span class="input-group-text"><i class="bi bi-person-circle"></i></span>
      <input type="text" class="form-control" placeholder="Username" formControlName="username" />
    </div>

    <div class="input-group mb-3">
      <span class="input-group-text"><i class="bi bi-key-fill"></i></span>
      <input type="password" class="form-control" placeholder="Password" formControlName="password" />
    </div>

    <div class="d-grid gap-2">
      @if (!isLoading) {
        <button type="submit" class="btn btn-primary" [disabled]="!loginform.valid">Login</button>
      }

      @if (isLoading) {
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Loading...</span>
        </button>
      }
    </div>
    <p></p>
    @if (isLoginError) {
      <div class="alert alert-danger" role="alert">{{ txtLoginError }}</div>
    }
    <article>{{ today | date: 'yyyy' }} {{ apptitle }} {{ version }}</article>
  </form>
</div>

<!--Change Password Modal -->
<div class="modal" tabindex="-1" aria-hidden="true" [ngStyle]="{ display: changePasswordDisplayStyle }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Change New Password</h5>
        </div>
        <div class="modal-body">
          <form [formGroup]="changePasswordForm">
            <div class="mb-3">
              <label class="form-label">New Password</label>
              <div class="input-group">
                <input
                  [type]="showNewPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="newPassword" />
                <span class="input-group-text">
                  <i
                    type="button"
                    [ngClass]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-fw fa-eye'"
                    (click)="showNewPassword = !showNewPassword"></i>
                </span>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Confirm Password</label>
              <div class="input-group">
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  class="form-control"
                  formControlName="confirmPassword" />
                <span class="input-group-text">
                  <i
                    type="button"
                    [ngClass]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-fw fa-eye'"
                    (click)="showConfirmPassword = !showConfirmPassword"></i>
                </span>
              </div>
            </div>
          </form>
          @if (isUpdatePasswordError) {
            <div class="mb-3">
              <div class="alert alert-danger" role="alert">{{ txtLoginError }}</div>
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closePopup()">Cancel</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="submitNewPassword()"
          [disabled]="!changePasswordForm.valid">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }@else {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
